<template>
  <div class="addMain wraper">
    <template>
      <el-backtop target=".wraper"></el-backtop>
    </template>
    <div v-if="$route.meta.routeList.length>1" class="returnBtn" @click="goBack()">
      <i class="el-icon-back"></i>
    </div>
    <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index)  in routeList" :key="index"
        :to="{ name: item.name,query:{id:item.query.id,flag:item.query.flag,name:item.query.name} }">
        {{item.name}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never">
      <div class="cardTop">
        <h1 v-if="flag!='edit'">创建网关协议</h1>
        <h1 v-if="flag=='edit'">编辑网关协议</h1>
      </div>
      <div class="cardBottom">
        <div class="addIntroduce">
          <h3 v-if="serverIp!=''">创建网关协议，以保证网关设备的连接。配置的IP地址为：<span
              style="font-weight: bold;color: #ff3d47">{{serverIp}}</span></h3>
        </div>
        <el-form ref="addForm" :model="addForm" :rules="rules">
          <el-form-item label="网关协议名称" prop="name"><br />
            <div class="subheading">输入网关协议名称，方便辨别网关协议。</div>
            <el-input v-model="addForm.name" placeholder="请输入" maxlength="200"></el-input>
          </el-form-item>
          <el-form-item label="协议编号" prop="code"><br />
            <div class="subheading" v-if="editCode == true">输入网关协议编号</div>
            <div class="subheading" v-else>网关协议编号默认系统生成</div>
            <div v-if="editCode == true">
              <el-input v-model="addForm.code" placeholder="请输入协议编号" :disabled="this.flag == 'edit'&&commuType!='4'"
                maxlength="255">
              </el-input>
              <el-button @click="createCode" type="text">系统生成</el-button>
            </div>
            <div v-else style="margin-top: 5px;margin-left: 5px">
              {{addForm.code}}
              <el-button v-if="this.flag != 'edit'||commuType=='4'" @click="editCode = true" type="text">编辑编号
              </el-button>
            </div>
          </el-form-item>
          <el-form-item label="模板类型" prop="analysisTemplateType"><br />
            <div class="subheading">请选择协议模板类型。</div>
            <el-radio-group v-model="addForm.analysisTemplateType">
              <el-radio :label="1">平台已有模板</el-radio>
              <el-radio :label="2">自有模板</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="心跳包的值" prop="heartbeat" v-if="addForm.analysisTemplateType == 1 && commuType == 1"><br />
            <div class="subheading">16进制字符串。</div>
            <el-input v-model="addForm.heartbeat" placeholder="请输入" maxlength="255"></el-input>
          </el-form-item>
          <el-form-item label="协议解析模板" prop="analysisTemplate" v-if="addForm.analysisTemplateType == 1"><br />
            <div class="subheading">请选择协议解析模板。</div>
            <el-radio-group v-model="addForm.analysisTemplate">
              <el-radio :label="1">DLT45-2007规约</el-radio>
              <el-radio :label="2">DLT45-1997规约</el-radio>
              <el-radio :label="3">ModbusTCP</el-radio>
              <el-radio :label="4">ModbusRTU</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="协议脚本文件" prop="analysisScriptAttachmentIdFileList" v-if="addForm.analysisTemplateType==2">
            <br />
            <div class="subheading">
              请
              <el-upload :disabled="analysisScript.length>0" style="display: inline" :action='uploadAnalysis'
                :show-file-list="false" class="upload-demo" :limit='1' accept='groovy'
                :file-list="analysisScriptAttachmentIdFileList" :before-upload="beforeAvatarUpload"
                :on-change="handlePictureCardPreview" :with-credentials='true' :headers="myHeaders" :data="tokenData"
                :on-success='analysisScriptUploadSuccess' :on-remove='analysisScriptUploadRemove'>
                <el-tooltip effect="dark" content="上传脚本时需删除原脚本" placement="top">
                  <el-button type="text">上传</el-button>
                </el-tooltip>
                <!--<i class="el-icon-upload"></i>-->
                <!--<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>-->
              </el-upload>
              或
              <el-button type="text" @click="editScript()">编写</el-button>
              协议脚本文件，如需帮助请阅读
              <el-button type="text" @click="help">帮助文档</el-button>
            </div>
            <div
              style="width:370px;height:180px;border:dotted 1px #cccccc;border-radius: 5px;margin-top:10px;padding:3px;overflow: hidden;">
              <div style="text-align: right;" v-if="analysisScript">
                <i class="el-icon-close" style="color:#DD5145;" title="清空脚本" @click="cleanScript"></i>&nbsp;
              </div>
              <pre
                style="color:#747DB0;width:100%;height:100%;text-overflow:ellipsis;overflow: hidden;">{{showScript}}</pre>
            </div>
          </el-form-item>

          <el-form-item label="通信端口（除TCP、UDP外，不用修改）" prop="commuPort"><br />
            <el-row>
              <el-col :span="12">
                <div class="subheading" v-if="commuType == 1 || commuType == 2">请输入通信端口，范围[5000-65535]，为保证正常，建议使用推荐端口。
                </div>
                <el-input v-model.number="addForm.commuPort" placeholder="请输入"
                  :readonly="!(commuType == 1 || commuType == 2)" maxlength="11"></el-input>
                <el-button v-if="(commuType == 1 || commuType == 2)&&!showPortList" type="success" @click="getPort">推荐
                </el-button>
                <el-button v-if="(commuType == 1 || commuType == 2)&&showPortList" @click="showPortList = false">取消
                </el-button>
              </el-col>
              <el-col :span="12">
                <el-collapse-transition>
                  <div v-show="showPortList">
                    <el-radio-group v-model="addForm.commuPort" v-if="portList.length>0">
                      <el-radio v-for="(port,index) in portList" :label="port" :key="index"></el-radio>
                    </el-radio-group>
                    <div style="color:#F56C6C" v-else>
                      无可用推荐端口，请联系管理员。
                    </div>
                  </div>
                </el-collapse-transition>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="协议说明文档附件" prop="attachmentId"><br />
            <div class="subheading">
              请上传协议的说明文档，文件大小不超过20MB。
            </div>
            <el-upload :action='upload' show-file-list class="upload-demo" :limit='1' :file-list="attachmentIdFileList"
              :with-credentials='true' :headers="myHeaders" :data="tokenData" :on-success='attachmentIdUploadSuccess'
              :on-error="attachmentUploadFail"
              accept="application/pdf,text/plain,text/markdown,application/msword,application/x-zip-compressed,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              :before-upload="beforeDocUpload" :on-remove='attachmentIdUploadRemove' drag>
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
          </el-form-item>
          <el-form-item label="协议使用说明" prop="manual"><br />
            <div class="subheading">请简要填写协议使用说明。</div>
            <el-input type="textarea" :rows="3" v-model="addForm.manual" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="text" @click="cancelAdd">取消</el-button>
            <el-button type="primary" v-if="flag!='edit'" @click="onSubmit('addForm')">创建网关协议</el-button>
            <el-button type="primary" v-if="flag=='edit'" @click="eidtOnSubmit('addForm')">更新网关协议</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-dialog title="脚本编写" :visible.sync="scriptDialog" top="10px" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false" width="90%">
      <div style="margin-top: -30px">
        <script-debug-component :initVal="scriptInitVal" :script="scriptContent" @changeScript="changeScript">
        </script-debug-component>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="scriptDialog = false">关 闭</el-button>
        <el-button type="primary" @click="saveScript">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import API from "../../api/api";
  import scriptDebugComponent from '../../components/scriptDebugComponent'

  export default {
    components: {
      scriptDebugComponent
    },
    data() {
      var checkCommuPort = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('端口不能为空'));
        }
        setTimeout(() => {
          if (!Number.isInteger(value)) {
            callback(new Error('请输入数字值'));
          } else {
            if (value > 65535 || value < 1) {
              callback(new Error('数值必须在1-65535之间'));
            } else {
              callback();
            }
          }
        }, 500);
      };
      return {
        user_name: this.$cookies.get("user_name"),
        commuType: sessionStorage.getItem('commuType'),
        myHeaders: {
          Authentication: sessionStorage.getItem('token')
        },
        routeList: this.$route.meta.routeList,
        flag: this.$route.query.flag,
        rules: {
          name: [{
            required: true,
            message: "请输入网关协议名称",
            trigger: "blur"
          }],
          code: [{
            required: true,
            message: "请输入协议编号",
            trigger: "blur"
          }],
          analysisTemplateType: [{
            required: true,
            message: "请选择解析模板类型",
            trigger: "blur"
          }],
          heartbeat: [{
            pattern: /^[0-9a-zA-Z]+$/,
            message: "请填写16进制字符串",
            trigger: "blur"
          }],
          analysisTemplate: [{
            required: true,
            message: "请选择协议解析模板",
            trigger: "change"
          }],
          commuPort: [{
            validator: checkCommuPort,
            trigger: 'change'
          }]
        },

        addForm: {
          code: '',
          analysisTemplateType: 1, //解析模板类型
          analysisTemplate: '', //解析模板
          analysisScript: '', //内容
          analysisScriptAttachmentId: '', //id
          analysisScriptMd5: '', //名称
          attachmentName: '',
          attachmentId: '',
          type: 2,
          commuPort: '',
        },
        attachmentIdFileList: [],
        analysisScriptAttachmentIdFileList: [],
        upload: API.uploadFile(), //上传地址
        uploadAnalysis: API.uploadAnalysis(), //上传脚本地址
        analysisScriptAttachmentId: '', //装着协议脚本文本的id(不可多个)
        doUpload: false,
        analysisScript: '',
        analysisScriptMd5: '',
        attachmentId: '', //装着协议说明文档附件的id(不可多个)
        attachmentName: '',
        scriptDialog: false, //脚本编写弹窗
        scriptContent: '', //脚本内容
        scriptInitVal: '', //脚本初始化值
        showScript: "请上传或编写脚本文件", //脚本内容快照展示
        portList: [], //推荐端口列表
        showPortList: false,
        serverIp: '', //服务器Ip
        editCode: false, //手动编辑协议编号，默认系统生成
        developDocumentLink: ''
      };
    },
    watch: {
      analysisScript(newVal, oldVal) {
        if (newVal == '') {
          return false
        }
        var reg = new RegExp('/r/n', "g")
        var text = newVal.replace(reg, '\n');
        this.showScript = text;
      }
    },
    computed: {
      tokenData: function () {
        return {
          access_token: this.$cookies.get('access_token')
        }
      }
    },
    created() {
      API.getDefaultPort().then(res => {
        if (res.code == 1) {
          if (this.commuType == 3) {
            if (!res.data.mqttPort) {
              this.$message({
                message: 'mqtt协议默认端口未配置',
                type: 'error'
              });
            } else {
              this.addForm.commuPort = parseInt(res.data.mqttPort);
            }
          }
          if (this.commuType == 4) {
            if (!res.data.httpPort) {
              this.$message({
                message: 'http协议默认端口未配置',
                type: 'error'
              });
            } else {
              this.addForm.commuPort = parseInt(res.data.httpPort);
            }
          }
          if (this.commuType == 5) {
            if (!res.data.coapPort) {
              this.$message({
                message: 'coap协议默认端口未配置',
                type: 'error'
              });
            } else {
              this.addForm.commuPort = parseInt(res.data.coapPort);
            }
          }
        } else {
          this.$message({
            message: '协议默认端口未配置',
            type: 'error'
          });
        }
      });
    },
    methods: {

      //跳转到帮助文档
      help() {
        this.getDevelopDocumentLink()
        setTimeout(() => {
          window.open(this.developDocumentLink);
        }, 200);
      },

      //获取帮助文档地址
      getDevelopDocumentLink() {
        if (sessionStorage.getItem("developDocumentLink")) {
          this.developDocumentLink = sessionStorage.getItem("developDocumentLink")
        } else {
          API.getDictionaryListByCode({
            typeCode: "developDocumentLink"
          }).then(res => {
            if (res.code === 1) {
              var dictionaryList = res.data.dictionaryList
              if (dictionaryList.length > 0) {
                this.developDocumentLink = dictionaryList[0].content;
                sessionStorage.setItem("developDocumentLink", this.developDocumentLink)
              }
            }
          })
        }
      },

      //当页面为编辑状态flag==edit时要获取到当前编辑的信息
      getMage() {
        if (this.flag == 'edit') {
          let id = this.$route.query.id
          API.platformMduProtocol(id).then(res => {
            if (res.code == 1) {
              this.addForm = res.data.mduProtocol

              if (res.data.mduProtocol.analysisScriptAttachmentId != null) {
                let nalysisScriptAttachmentIdObj = {
                  name: res.data.mduProtocol.analysisScriptMd5,
                  id: res.data.mduProtocol.analysisScriptAttachmentId
                }
                this.analysisScriptMd5 = this.addForm.analysisScriptMd5
                this.analysisScriptAttachmentIdFileList.push(nalysisScriptAttachmentIdObj)
                this.analysisScriptAttachmentId = res.data.mduProtocol.analysisScriptAttachmentId
                this.analysisScript = res.data.mduProtocol.analysisScript
              }
              if (res.data.mduProtocol.attachmentId != null) {
                let attachmentIdObj = {
                  name: res.data.mduProtocol.attachmentName,
                  id: res.data.mduProtocol.attachmentId
                }
                this.attachmentIdFileList.push(attachmentIdObj)
                this.attachmentId = res.data.mduProtocol.attachmentId
              }
            } else {
              this.$message.error(res.msg);
            }
          })
        } else {
          return false
        }
      },
      // 上传文件浏览
      handlePictureCardPreview(file) {
        let filecontent = {
          uid: file.uid,
          name: file.name,
          status: file.status
        }
        this.analysisScriptAttachmentIdFileList = []
        this.analysisScriptAttachmentIdFileList.push(filecontent)
        this.doUpload = true
      },
      //上传协议脚本文件成功时的钩子
      analysisScriptUploadSuccess(res, file, fileList) {
        if (res.code == 1) {
          this.analysisScriptAttachmentId = res.data.id
          this.analysisScript = res.data.content
          this.analysisScriptMd5 = res.data.name
        } else {
          this.$message.error(res.msg);
        }
      },
      beforeAvatarUpload(file) {
        let index = file.name.lastIndexOf("\."); //最后一个.号
        let type = file.name.substring(index + 1, file.name.length); //获取到文件的类型，
        const isLt4M = file.size / 1024 / 1024 <= 4 //图片大小不超过4MB
        if (!isLt4M) {
          this.$message.error('上传文件大小不能超过 4M!');
          return false
        }
        if (type == "groovy") {
          return true
        } else {
          this.$message.error('上传的文件类型不正确（必须为groovy文件类型），请重新上传');
          this.analysisScriptAttachmentIdFileList = []
          return false
        }
      },

      beforeDocUpload(file) {
        let index = file.name.lastIndexOf("."); //最后一个.号
        let type = file.name.substring(index + 1, file.name.length); //获取到文件的类型，
        const isLt20M = file.size / 1024 / 1024 <= 20; //图片大小不超过20MB
        if (!isLt20M) {
          this.$message.error("上传文件大小不能超过20M!");
          return false;
        }
        if (type == "zip" || type == "pdf" ||
          type == "doc" || type == "png" ||
          type == "jpg" || type == "md" ||
          type == "txt" || type == "docx") {
          return true;
        } else {
          this.$message.error(
            "上传的文件类型不正确,必须为zip,pdf,doc,docx,png,jpg,md,txt类型,请重新上传"
          );
          return false;
        }
      },

      attachmentUploadFail() {
        this.$message.error('上传失败')
      },

      //移除协议脚本文件
      analysisScriptUploadRemove(file, fileList) {
        if (file.response || file.id) {
          this.analysisScriptAttachmentId = ''
          this.analysisScriptAttachmentIdFileList = []
        }
      },
      //上传协议说明文档附件
      attachmentIdUploadSuccess(res, file, fileList) {
        if (res.code == 1) {
          this.attachmentId = res.data.id;
        } else if (res.code == 0) {
          this.$message.error(res.msg)
          this.attachmentIdFileList = []
        }
      },
      //移除协议说明文档附件
      attachmentIdUploadRemove(file, fileList) {
        if (file.response) {
          this.attachmentId = ''
        }
      },
      //实时获取编写的脚本内容
      changeScript(scriptText) {
        this.scriptContent = scriptText
      },
      //编写脚本按钮
      editScript() {
        this.scriptDialog = true
        this.scriptInitVal = this.analysisScript
      },
      saveScript() { //保存编写的脚本弹窗
        this.analysisScript = this.scriptContent;
        this.scriptDialog = false;
        this.analysisScriptAttachmentId = ''
        this.analysisScriptAttachmentIdFileList = []
      },
      cleanScript() {
        this.scriptContent = ''
        this.analysisScript = ''
        this.showScript = '请上传或编写脚本文件'
        this.analysisScriptAttachmentId = ''
        this.analysisScriptAttachmentIdFileList = []
      },
      //创建网关协议
      onSubmit(formName) {
        let _this = this;
        let _API = API;
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (_this.addForm.analysisTemplateType == 2) {
              _this.addForm.analysisScriptAttachmentId = _this.analysisScriptAttachmentId
              _this.addForm.analysisScript = _this.analysisScript
              _this.addForm.analysisScriptMd5 = _this.analysisScriptMd5
            }
            if (_this.attachmentId != '') {
              _this.addForm.attachmentId = _this.attachmentId
              _this.addForm.attachmentName = _this.attachmentName
            }

            if (_this.addForm.analysisTemplateType == 2 && _this.analysisScript == "") {
              _this.$message({
                message: '请上传或编写协议脚本',
                type: 'error'
              });
              return
            }
            _this.addForm.commuType = sessionStorage.getItem('commuType');
            if (this.user_name == 'suadmin') {
              _API.addPlatformMduProtocolCommon(_this.addForm).then(res => {
                if (res.code == 1) {
                  _this.$message({
                    message: '创建网关协议成功',
                    type: 'success'
                  });
                  var openNoviceGuide = sessionStorage.getItem("openNoviceGuide") ? sessionStorage.getItem(
                    "openNoviceGuide") : "false";
                  var noviceGuideStep = sessionStorage.getItem("noviceGuideStep") ? sessionStorage.getItem(
                    "noviceGuideStep") : '0';
                  if (openNoviceGuide == "true" && noviceGuideStep == '0') {
                    this.changeNoviceGuideStep('noviceGuideStep', 1);
                    //页面跳转
                    this.$router.push({
                      path: "/device/moduleAdd",
                    });
                  } else {
                    this.$router.push({ //跳转回原来页面
                      name: this.routeList[this.routeList.length - 2].name,
                      params: {
                        data: this.$route.query.data
                      }
                    });
                  }
                } else {
                  _this.$message({
                    message: res.msg,
                    type: 'error'
                  });
                }
              });
              return;
            }
            _API.addPlatformMduProtocolPrivate(_this.addForm).then(res => {
              if (res.code == 1) {
                _this.$message({
                  message: '创建网关协议成功',
                  type: 'success'
                });
                var openNoviceGuide = sessionStorage.getItem("openNoviceGuide") ? sessionStorage.getItem(
                  "openNoviceGuide") : "false";
                var noviceGuideStep = sessionStorage.getItem("noviceGuideStep") ? sessionStorage.getItem(
                  "noviceGuideStep") : '0';
                if (openNoviceGuide == "true" && noviceGuideStep == '0') {
                  this.changeNoviceGuideStep('noviceGuideStep', 1);
                  //页面跳转
                  this.$router.push({
                    path: "/device/moduleAdd",
                  });
                } else {
                  this.$router.push({ //跳转回原来页面
                    name: this.routeList[this.routeList.length - 2].name,
                    params: {
                      data: this.$route.query.data
                    }
                  });
                }
              } else {
                _this.$message({
                  message: res.msg,
                  type: 'error'
                });
              }
            });
          } else {
            _this.$message({
              message: '请填写完所有必填项',
              type: 'error'
            });
            return false;
          }
        });
      },
      //更新网关协议
      eidtOnSubmit(formName) {
        let _this = this;
        let _API = API;
        this.$refs[formName].validate(valid => {
          if (valid) {
            //********************先初始化上传附件的数据保证下面判断的数据正确赋值************************* */
            _this.addForm.analysisScriptAttachmentId = ''
            _this.addForm.analysisScript = ''
            _this.addForm.analysisScriptMd5 = ''
            _this.addForm.attachmentId = ''
            _this.addForm.attachmentName = ''
            //********************先初始化上传附件的数据保证下面判断的数据正确赋值************************* */

            if (_this.addForm.analysisTemplateType == 2) {
              _this.addForm.analysisScriptAttachmentId = _this.analysisScriptAttachmentId
              _this.addForm.analysisScript = _this.analysisScript
              _this.addForm.analysisScriptMd5 = _this.analysisScriptMd5
            }
            if (_this.attachmentId != '') {
              _this.addForm.attachmentId = _this.attachmentId
              _this.addForm.attachmentName = _this.attachmentName
            }

            if (_this.addForm.analysisTemplateType == 2 && _this.analysisScript == "") {
              _this.$message({
                message: '请上传或编写协议脚本',
                type: 'error'
              });
              return
            }
            if (this.user_name == 'suadmin') {
              _API.editCommonPlatformMduProtocol(this.$route.query.id, _this.addForm).then(res => {
                if (res.code == 1) {
                  _this.$message({
                    message: '更新网关协议成功',
                    type: 'success'
                  });
                  _this.$router.push({
                    path: "/device/protocolLibraryManagement",
                  });
                } else {
                  _this.$message({
                    message: res.msg,
                    type: 'error'
                  });
                }
              });
              return;
            }
            _API.editPrivatePlatformMduProtocol(this.$route.query.id, _this.addForm).then(res => {
              if (res.code == 1) {
                _this.$message({
                  message: '更新网关协议成功',
                  type: 'success'
                });
                _this.$router.push({
                  path: "/device/protocolLibraryManagement",
                });
              } else {
                _this.$message({
                  message: res.msg,
                  type: 'error'
                });
              }
            });
          } else {
            _this.$message({
              message: '请填写完所有必填项',
              type: 'error'
            });
            return false;
          }
        });
      },
      //取消编辑
      cancelAdd() {
        if (this.flag != 'edit' && this.$route.query.data) {
          this.$router.push({ //跳转回原来页面
            name: this.routeList[this.routeList.length - 2].name,
            params: {
              data: this.$route.query.data
            }
          });
        } else {
          this.$router.history.go(-1)
        }
      },
      //获取推荐端口
      getPort() {
        API.getPort({
          commuType: this.commuType
        }).then(res => {
          if (res.code == 1) {
            this.showPortList = true;
            this.portList = res.data.ports
          }
        });
      },
      //生成code
      createCode() {
        var commuType = sessionStorage.getItem("commuType")
        var prefix = commuType == '1' ? 'TCP_' : commuType == '2' ? 'UDP_' : commuType == '3' ? 'MQTT_' : commuType ==
          '4' ? 'HTTP_' : 'COAP_'
        var time = new Date().getTime();
        this.editCode = false
        this.addForm.code = prefix + time;
      }
    },
    mounted() {
      var serverIp = sessionStorage.getItem("serverIp")
      if (!serverIp) {
        API.getServerIP().then(res => {
          if (res.code == 1) {
            this.serverIp = res.data.serverIp
            sessionStorage.setItem("serverIp", res.data.serverIp)
          }
        });
      } else {
        this.serverIp = serverIp
      }
      this.getMage();
      this.createCode()
    }
  };

</script>



// WEBPACK FOOTER //
// src/views/platform/protocolAdd.vue